var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.isLoading)?_vm._t("default"):_vm._e(),_c('BLoading',{attrs:{"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }